module.exports = __webpack_public_path__ + "img/151.b8b66e70.png";